function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#ff4f8b;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-CloudWatch_Rule_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M16.17,18.05l-2.86-2.82-11.82,0L1.58,2H14.14L17,4.77H48.5V18ZM3.5,13.21l10.63,0L17,16.05,46.51,16V6.77H16.16L13.32,4H3.57Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M16.16,33l-2.85-2.81H1.49V17H14.2L17,19.79H48.49V33ZM3.49,28.22H14.14L17,31H46.5V21.8H16.13L13.36,19H3.49Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M48.5,48,16.19,48l-2.85-2.77H1.49V32H14.07L17,34.78H48.5ZM17,46,46.5,46V36.78H16.17L13.25,34H3.49v9.27H14.15Z"
}), React.createElement("polygon", {
  className: "cls-2",
  points: "37.14 29.68 34.6 27.13 36.02 25.72 37.26 26.97 42.17 22.86 43.45 24.39 37.14 29.68"
}), React.createElement("polygon", {
  className: "cls-2",
  points: "36.89 44.62 34.35 42.08 35.76 40.67 37.01 41.91 41.92 37.81 43.2 39.34 36.89 44.62"
}), React.createElement("rect", {
  className: "cls-2",
  x: 38.98,
  y: 7.46,
  width: 2,
  height: 7.91,
  transform: "translate(3.6 31.55) rotate(-44.9)"
}), React.createElement("rect", {
  className: "cls-2",
  x: 36.01,
  y: 10.41,
  width: 7.91,
  height: 2,
  transform: "translate(3.64 31.61) rotate(-45)"
}));

var SvgAwsCloudWatchEventRule = function SvgAwsCloudWatchEventRule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsCloudWatchEventRule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-CloudWatch_Event_Rule.01a2e025.svg";
export { ForwardRef as ReactComponent };